import { Component } from 'preact';

import type { I_ErrorBoundaryProps, T_ErrorBoundaryState } from '@/types/ErrorBoundary';

export class ErrorBoundary extends Component<I_ErrorBoundaryProps, T_ErrorBoundaryState> {
  state: T_ErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): T_ErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error) {
    console.error('[ERROR]:', error);
    // NOTE: can send to Sentry or another logger
  }

  render() {
    return (
      <>
        {this.props.children}
        {this.state.error && (
          <div className='bg-red-700 p-4 text-center text-white'>
            Something went wrong. Please refresh.
          </div>
        )}
      </>
    );
  }
}
